import React from "react";
import { Button, Icon } from "aible";

import styles from "./style.module.css";

import { Popover, OverlayTrigger } from "react-bootstrap";

export default class TileOptionsButton extends React.PureComponent {
  render() {
    const { overlay, title, icon, className, ...retProps } = this.props;
    return (
      <OverlayTrigger
        placement="top"
        trigger={overlay || title ? ["hover"] : []}
        rootClose
        overlay={
          <Popover id="popover-positioned-top">
            {overlay ? overlay : <div className={styles.popoverList}>{title}</div>}
          </Popover>
        }
      >
        <Button className={styles.tileOptionsButton + " " + (className ? className : "")} {...retProps}>
          {typeof icon === "string" ? <Icon type={icon} size={15} /> : icon}
        </Button>
      </OverlayTrigger>
    );
  }
}
